import httpClient from '../utils/httpClient';

export const insertEnquiry = async (requestParams) => {
    const response = await httpClient.post('/enquiry/create-enquiry', requestParams);
    return response.data;
};

export const GetEnquiryDetail = async (requestParams) => {
    const response = await httpClient.post('/enquiry/GetEnquiryDetail', requestParams);
    return response.data;
};

export const GetEnquiry = async (requestParams) => {
    const response = await httpClient.post('/enquiry/GetEnquiry', requestParams);
    return response.data;
};

export const GetEnquiryCount = async (requestParams) => {
    const response = await httpClient.post(`/enquiry/get-enquiry-count`, requestParams || {});
    return response.data;
};